import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AudienceManagementComponent } from './audience-management.component';
import { AnalyticsListComponent } from './analytics-list/analytics-list.component';
import { AnalyticsDetailsComponent } from './analytics-details/analytics-details.component';

const routes: Routes = [
  {
    path:'',
    component: AudienceManagementComponent,
    children: [
      {
        path:'analytics-list',
        component: AnalyticsListComponent
      },
      {
        path: 'analytics-details/:sessionId',
        component: AnalyticsDetailsComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AudienceManagementRoutingModule { }
